import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SLICE_BASE_NAME } from './constants'

export type UserState = {
    avatar?: string
    userName?: string
    email?: string
    authority?: string[]
    token?: string
    adminToken?: {
        token?: string
    }
}

const initialState: UserState = {
    avatar: '',
    userName: '',
    email: '',
    authority: [],
    token: '',
}

const userSlice = createSlice({
    name: `${SLICE_BASE_NAME}/user`,
    initialState,
    reducers: {
        setUser(state, action: PayloadAction<UserState>) {
            // console.log(JSON.stringify(action.payload))
            state.avatar = action.payload?.avatar
            state.email = action.payload?.email
            state.userName = action.payload?.userName
            state.authority = action.payload?.authority
            state.token = action.payload?.adminToken?.token
        },
    },
})

export const { setUser } = userSlice.actions
export default userSlice.reducer
